import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { RouteComponentProps, useHistory, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

import { AmountFormat, DateFormat } from 'components/common';
import { DocumentDetailsPage } from "components/common/DocumentDetailsPage";
import StepsItemView from "components/common/StepsItemView";
import { getDocument } from "services/users";

const config = [
    'Total',
    'Price',
    'Quantity',
    'Currency Type',
    'Type',
    'Approval Date',
    'Step'
];

type RouteParams = {
    id: string;
};

const TaxesDetails: React.FC<RouteComponentProps> = () => {
    const { t } = useTranslation();
    const { id } = useParams<RouteParams>();

    const history = useHistory();
    const { user } = useSelector(
        (state: any) => state.authReducer
    );

    const [document, setDocument] = useState<any>(null);

    const [data, setData] = useState<any>(null);

    const processDocument = (doc: any) => {
        setDocument(doc);

        const data: any[] = [{
        id: 0,
        step: 1,
        status: "passed",
        text: t("tax_plain"),
        currency_type: "",
        currency: "",
        quantity: "",
        price: "",
        total: "",
        approval_date: "",
        type: ""
    }];

    doc.meta.movements.forEach((item: any) => {

        // 1️⃣ Original TAX movement (USD)
        data.push({
            id: item.id,
            step: null,
            status: "passed",
            text: `${item.currency} ⇄ USD`,
            currency_type: t("crypto_string"),
            currency: item.currency,
            quantity: Math.abs(item.usd_value),
            quantityDecimals: 4,
            price: Math.abs(item.price),
            priceDecimals: 4,
            total: Math.abs(item.amount),
            totalDecimals: 8,
            approval_date: item.dt,
            type: "SELL"
        });

        // 2️⃣ USD → ILS conversion line
        data.push({
            id: `${item.id}-ils`,
            step: null,
            status: "passed",
            text: `USD ⇄ ILS`,
            currency_type: t("fiat_string"),
            currency: "ILS",
            quantity: Math.abs(item.usd_value),
            quantityDecimals: 2,
            price: item.price_ils,              // USD → ILS rate
            priceDecimals: 4,
            total: Math.abs(item.value_ils),    // value in ILS
            totalDecimals: 2,
            approval_date: item.dt,
            type: "SELL"
        });

        data.push({
            id: `${item.id}-ils`,
            step: null,
            status: "passed",
            text: `ILS ⇄ ILS`,
            currency_type: t("fiat_string"),
            currency: "ILS",
            quantity: Math.abs(item.value_ils),
            quantityDecimals: 2,
            price: 1,            
            priceDecimals: 4,
            total: Math.abs(item.value_ils),    
            totalDecimals: 2,
            approval_date: item.dt,
            type: "TAX"
        });
    });

    setData(data);
    };

    const reloadDocuments = () => {
        getDocument(id).then(doc => {
            if (doc) {
                processDocument(doc);
            }
        });
    };

    useEffect(() => {
        if (user) {
            reloadDocuments();
        } else {
            history.push('/');
        }
    }, []);

    
        useEffect(() => {
            if (!user) {
                return history.push('/');
            }
        }, [user]);

    return (
        <DocumentDetailsPage
            title={t("tax_string")}
            columns={config}
            documentData={document}
            stepsData={data}
            processing={false}
            itemComponent={StepsItemView}
            summary={(<>
                    <div className="backoffice-tab-content">


                        <div className={"backoffice-list-items"}>
                          
                        </div>
                    </div>
                </>
            )}
        />
    );
};

export default TaxesDetails;
